import { render, staticRenderFns } from "./auth_location.vue?vue&type=template&id=235886e6&"
import script from "./auth_location.vue?vue&type=script&lang=js&"
export * from "./auth_location.vue?vue&type=script&lang=js&"
import style0 from "./auth_location.vue?vue&type=style&index=0&id=235886e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports